import * as yup from 'yup';

import { STREFA_KOD_MAX_DLUGOSC, STREFA_NAZWA_MAX_DLUGOSC } from 'api/strefy/strefy.enum';
import { useLocale } from 'hooks/useLocale/useLocale';
import { AppMessages } from 'i18n/messages';

/** Mirrors `CreateStrefaRequestDto`: both fields are trimmed, `kod` is unique (exact match) across the whole structure. */
export const useAddZoneValidation = (allZoneCodes: string[]) => {
  const { formatMessage } = useLocale();

  const schema = yup.object().shape({
    kod: yup
      .string()
      .trim()
      .max(STREFA_KOD_MAX_DLUGOSC, formatMessage({ id: AppMessages['definitions.zones.validation.code'] }))
      .test(
        'check zone code duplicate',
        formatMessage({ id: AppMessages['definitions.zones.add.code.duplicate'] }),
        (code) => !(code && allZoneCodes.includes(code)),
      )
      .required(formatMessage({ id: AppMessages['common.validation.required'] })),
    nazwa: yup
      .string()
      .trim()
      .max(STREFA_NAZWA_MAX_DLUGOSC, formatMessage({ id: AppMessages['definitions.zones.validation.name'] }))
      .required(formatMessage({ id: AppMessages['common.validation.required'] })),
  });

  return { schema };
};
